import React from 'react';

import _ from 'lodash';

import FieldGroup from '../../Fields/FieldGroup';
import Field from '../../Fields/Field';
import InputSelectField from '../../Fields/InputSelectField';
import InputRadioGroupField from '../../Fields/InputRadioGroupField';
import SurveyQuestionTable from '../../Fields/SurveyQuestionTable';

import SurveyQuestion from '../../../Entities/SurveyQuestion';


class SettingsTerminationPanel extends React.Component {
  _onInputChange(inputId) {
    return value => {
      switch (inputId) {
        case 'termination_notice_day':
          if (value !== null) value = parseInt(value, 10);
          break;
        case 'provide_survey':
          if (value !== null) value = (value === 'true') ? true : false;
          break;
        default:
      }

      this.props.onValueChange(inputId, value);
    };
  }


  _onSurveyQuestionChange(type) {
    return (ident, value) => {
      const surveyQuestions = _.cloneDeep(this.props.settings.fields.survey_questions);

      // Define ident for new survey questions being added
      if (ident === null) ident = surveyQuestions[type].value.length;

      if (value === null) {
        // Removing survey question
        surveyQuestions[type].value.splice(ident, 1);
      }
      else {
        surveyQuestions[type].value[ident] = value;
      }

      this._onInputChange('survey_questions')(surveyQuestions);
    };
  }


  handleAddTerminationSurveyQuestionClick = () => {
    this._onSurveyQuestionChange('termination')(null, new SurveyQuestion('TERMINATION'));
  }


  render() {
    const {
      editMode,
      settings,
      fieldConfiguration
    } = this.props;

    const {
      facilitySettings: facilitySettingsFieldConfiguration
    } = fieldConfiguration;

    const requiredFieldState = editMode;

    const terminationNoticeDayOptions = [
      { value: null, label: '' },
      ...facilitySettingsFieldConfiguration.termination_notice_day.options[settings.fields.billing_timing.value] || []
    ];

    const terminationSurveyQuestionTableRows = settings.fields.survey_questions.termination.value.map((surveyQuestion, index) => {
      return { ident: index, data: surveyQuestion };
    });

    return (
      <div>
        <FieldGroup label="Termination Policy">
          <Field label="Required Notice"
            id="parkchirp--settings--termination-notice-day"
            required={requiredFieldState}
            layout="columns">
            {(settings.fields.billing_timing.value === null) &&
              <span style={{ fontStyle: 'italic' }}>Billing Timing must be selected before entering this value.</span>
            }
            {(settings.fields.billing_timing.value !== null) &&
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <InputSelectField inputId="parkchirp--settings--termination-notice-day"
                  options={terminationNoticeDayOptions}
                  value={settings.fields.termination_notice_day.value}
                  editMode={editMode}
                  onChange={this._onInputChange('termination_notice_day')}
                />
                {(settings.fields.billing_timing.value === 'CALENDAR_DAY') &&
                  <span style={{ marginLeft: '0.3em' }}>day of the month.{(editMode) && <span style={{ fontStyle: 'italic' }}> (Select a day that is after the 1st of the month, but prior to the Billing Timing Day.)</span>}</span>
                }
                {(settings.fields.billing_timing.value === 'ROLLING_PERIOD') &&
                  <span style={{ marginLeft: '0.3em' }}>days prior to the bill being created</span>
                }
              </div>
            }
          </Field>
          <Field label="Provide Survey"
            id="parkchirp--settings--provide-survey"
            required={requiredFieldState}
            layout="columns">
            <InputRadioGroupField inputId="parkchirp--settings--provide-survey"
              options={facilitySettingsFieldConfiguration.provide_survey.options}
              value={settings.fields.provide_survey.value}
              onChange={this._onInputChange('provide_survey')}
              editMode={editMode}
            />
          </Field>
          {(settings.fields.provide_survey.value === true) &&
            <Field>
              <SurveyQuestionTable inputId="parkchirp--settings--termination-survey-questions"
                surveyQuestionRows={terminationSurveyQuestionTableRows}
                onSurveyQuestionChange={this._onSurveyQuestionChange('termination')}
                editMode={editMode}
              />
              {(editMode) &&
                <div className="parkchirp--settings--termination-panel--termination-survey-questions--action-container">
                  <button type="button"
                    className="parkchirp--button-as-link"
                    onClick={this.handleAddTerminationSurveyQuestionClick}>
                    Add Survey Question
                  </button>
                </div>
              }
            </Field>
          }
        </FieldGroup>
      </div>
    );
  }
}
export default SettingsTerminationPanel;
